"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var Select = /** @class */ (function () {
    function Select() {
        this.init();
    }
    Select.getInstance = function () {
        return new Select();
    };
    Select.prototype.init = function () {
        var $select = $('select');
        $select.on('change', function () {
            $(this).addClass('option-selected');
        });
    };
    return Select;
}());
exports.default = Select;
